import type { ReactNode } from "react";

export const Eyebrow = ({ children }: { children: ReactNode }) => (
  <p className="text-[13px] font-semibold text-brand-700">{children}</p>
);

export const SettingsIcon = ({ children }: { children: ReactNode }) => (
  <span className="flex size-10 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-700">
    {children}
  </span>
);
